export default __webpack_public_path__ + "static/image_acceuil@2x-72ca6efe253a41b3644788f40c6f04bb.jpg";